import { render, staticRenderFns } from "./Demanda.vue?vue&type=template&id=524c96c0&scoped=true&"
import script from "./Demanda.vue?vue&type=script&lang=js&"
export * from "./Demanda.vue?vue&type=script&lang=js&"
import style0 from "./Demanda.vue?vue&type=style&index=0&id=524c96c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524c96c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
